/** @format */

import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { z } from "zod";

import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

const HomePage = lazyWithRetry(() => import("@/pages/Home/Home"));

const homeSearchSchema = z.object({
  modal: z.enum(["login", "register", "resetPassword", "profile"]).optional(),
  year: z.union([z.string(), z.number()]).optional(),
});

export const Route = createFileRoute("/")({
  validateSearch: homeSearchSchema,
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <HomePage />
    </Suspense>
  ),
  errorComponent: RouteErrorComponent,
});
